import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { courseIconMap } from '@/constants/constants';

const ExploreCourseLevel = ({ courseLevelData }: any) => {
  return (
    <div className="mx-auto mb-4 mt-8 w-full px-3 font-sans sm:px-0 lg:w-4/5 lg:max-w-screen-xl">
      <div className="w-full text-center text-xl font-semibold leading-tight tracking-tight md:text-2xl xl:text-3xl">
        <span className="text-primary ">{`Ready to Learn?`}</span>
        <br />
        Start by Choosing Your Level
      </div>
      <p className="mb-5 mt-2 text-center text-xs text-primary-gray lg:text-base">
        Discover courses tailored to every skill level. Start learning at your pace with options designed to match your
        experience and goals.
      </p>
      <div className="grid w-full grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {Object.keys(courseIconMap).map((level) => {
          const course = courseLevelData?.find((course: any) => course?.course_level_name === level);
          if (!course || course?.streams?.length === 0) return null;
          const mapping = courseIconMap[level];

          // Filter streams based on the course level
          const filteredStreams = course?.streams?.filter((stream: any) => {
            return stream?.courses?.some((course: any) => course?.course_level?.course_level_name === level);
          });

          if (!filteredStreams || filteredStreams.length === 0) return null;
          return (
            <div key={course.id} className="!relative flex w-full flex-col rounded-lg border px-2 shadow-lg">
              <div className="flex w-full items-center justify-between gap-2 rounded-t-lg border-b px-1 py-3">
                <div className="flex items-center justify-end gap-x-2">
                  <Image
                    src={mapping.icon}
                    alt={mapping.displayName ?? 'default stream'}
                    width={500}
                    height={500}
                    className="size-9 object-fill lg:size-12 "
                  />
                  <div className="space-y-1">
                    <Link href={`/courses/${course?.course_level_url}`} className="text-sm font-semibold lg:text-base">
                      {mapping.displayName}
                    </Link>
                    <p className="text-xxs text-primary-gray lg:text-xs">{mapping.label}</p>
                  </div>
                </div>
              </div>
              <div className="flex flex-wrap items-center gap-2 px-1 py-3">
                {filteredStreams?.map((stream: any) => (
                  <Link
                    key={stream?.id}
                    href={`/courses/${stream?.stream_name
                      .toLowerCase()
                      .replace(/\s+/g, '-')}-${course?.course_level_url}`}
                  >
                    <p className="min-w-14 cursor-pointer rounded-full border border-[#D7D7D7] bg-[#F0F0F0] px-2.5 py-1.5 text-center text-xxs text-black hover:shadow-lg">
                      {stream?.stream_name}
                    </p>
                  </Link>
                ))}
              </div>
              <div
                style={{
                  position: 'absolute',
                  bottom: 0,
                  right: 0,
                  zIndex: -50,
                  width: '96px',
                  height: '96px',
                  background: `linear-gradient(to bottom right, transparent, transparent 50%, ${mapping.color})`,
                  opacity: 0.45,
                  borderRadius: '8px',
                }}
              ></div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ExploreCourseLevel;
